/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Manager_Guides_TitleInputs */

const en_knp_manager_guides_title = /** @type {(inputs: Knp_Manager_Guides_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP Guides`)
};

const fr_knp_manager_guides_title = /** @type {(inputs: Knp_Manager_Guides_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guides KNP`)
};

const de_knp_manager_guides_title = /** @type {(inputs: Knp_Manager_Guides_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP-Führer`)
};

const it_knp_manager_guides_title = /** @type {(inputs: Knp_Manager_Guides_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guide KNP`)
};

const ru_knp_manager_guides_title = /** @type {(inputs: Knp_Manager_Guides_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Гиды КНП`)
};

const es_knp_manager_guides_title = /** @type {(inputs: Knp_Manager_Guides_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guías del KNP`)
};

const zh_cn2_knp_manager_guides_title = /** @type {(inputs: Knp_Manager_Guides_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP 导游`)
};

const ja_knp_manager_guides_title = /** @type {(inputs: Knp_Manager_Guides_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNPガイド`)
};

const hi_knp_manager_guides_title = /** @type {(inputs: Knp_Manager_Guides_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केएनपी गाइड`)
};

const pt_pt2_knp_manager_guides_title = /** @type {(inputs: Knp_Manager_Guides_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guias do Parque Nacional Kruger`)
};

/**
* | output |
* | --- |
* | "KNP Guides" |
*
* @param {Knp_Manager_Guides_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_guides_title = /** @type {((inputs?: Knp_Manager_Guides_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_Guides_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_manager_guides_title(inputs)
	if (locale === "de") return de_knp_manager_guides_title(inputs)
	if (locale === "it") return it_knp_manager_guides_title(inputs)
	if (locale === "ru") return ru_knp_manager_guides_title(inputs)
	if (locale === "es") return es_knp_manager_guides_title(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_manager_guides_title(inputs)
	if (locale === "ja") return ja_knp_manager_guides_title(inputs)
	if (locale === "hi") return hi_knp_manager_guides_title(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_manager_guides_title(inputs)
	return en_knp_manager_guides_title(inputs)
});